import { render, staticRenderFns } from "./tableApproval.vue?vue&type=template&id=341f52a2&"
import script from "./tableApproval.vue?vue&type=script&lang=js&"
export * from "./tableApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports